import { Component, Element, h, Prop } from "@stencil/core";
import { getDataAttributes } from "../../lib/getDataAttributes";
import { Logger } from "../../lib/logger";

/**
 * The Zap Templates Element (ZTE). Switch to using `<zapier-workflow>` instead.
 *
 * @deprecated
 */
@Component({
  tag: "zapier-zap-templates",
  // Disable shadow DOM so that the `[data-theme="dark"]` selector from
  // `global.css` can apply to the `<zapier-workflow>` within. Otherwise we
  // would have to maintain our own theme state, which is surprisingly hard to
  // do considering that Stencil.js doesn't have an equivalent for React hooks
  // OR the ability to use class inheritance... So you can't abstract out the
  // details very well.
  shadow: false,
})
export class ZapierZapTemplates {
  @Element() element!: HTMLZapierZapTemplatesElement;

  @Prop() apps = "";
  @Prop() ids = "";
  @Prop() limit = 5;
  @Prop() categories = "";
  @Prop() theme: "auto" | "dark" | "light" = "light";
  @Prop() useThisZap?: "hide" | "show" = "show";
  @Prop() createWithoutTemplate?: "hide" | "show" = "show";
  @Prop() fbEmbed = "";
  @Prop({ reflect: true }) signUpFirstName = "";
  @Prop({ reflect: true }) signUpLastName = "";
  @Prop({ reflect: true }) signUpEmail = "";
  @Prop({ reflect: true }) clientId = "";

  componentDidLoad() {
    Logger.warn(
      "Please upgrade to the latest Zapier experience https://zapier.com/partner/embed/workflow",
    );
  }

  render() {
    return (
      <zapier-workflow
        internalAutoUpgradedFrom="zte"
        {...getDataAttributes(this.element)}
        internalApp={this.apps}
        templateIds={this.ids}
        templateLimit={this.limit}
        appCategories={this.categories}
        theme={this.theme}
        templateCtaDisplay={this.useThisZap}
        zapCreateFromScratchDisplay={this.createWithoutTemplate}
        internalFacebookEmbed={this.fbEmbed}
        signUpFirstName={this.signUpFirstName}
        signUpLastName={this.signUpLastName}
        signUpEmail={this.signUpEmail}
        clientId={this.clientId}
        // We can't safely use iframes in ADE implementations, so force the use
        // of popups
        embedMode="popup"
      />
    );
  }
}
